module.exports = __webpack_public_path__ + "01_medium_brown.8e464a27.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/01_medium_brown.png
// module id = rLLF
// module chunks = 0